
import { Component, OnInit, computed, inject, input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { UtilityService } from '../../../../services';
import { CommonFieldWidgetBase } from '../common-field-widget-base';
import { CommonMultiSelectField } from '../field';
import { getLabels } from '../field.labels';


@Component({
	selector: 'common-multiselect-field',
	imports: [FormsModule],
	templateUrl: './common-multiselect-field.widget.html',
	host: { '[class.d-none]': 'isExcluded()' },
	styles: [`
		.multiselect{
			width: 100%;
			padding: 0 0.75em;
			border: 1px solid #ddd;
    		word-break: break-word;
			background-color: #fff;
		}
	`],
})
export class CommonMultiselectFieldWidget<T> extends CommonFieldWidgetBase<T[], CommonMultiSelectField<T>> implements OnInit {
	private util = inject(UtilityService);

	public readonly field = input.required<CommonMultiSelectField<T>>();

	public readonly labels = computed(() => getLabels(this.field().config().isSpanish));


	ngOnInit() {
		this.onInit(this.field());
	}


	public onChange(value: T, checked: boolean) {
		//
		// On adding an input remove any selection that doesn't exist in the options.
		// E.g. Race other 'O' was removed but we still have the value set.
		//

		// Get all options that are marked as "independent select" (e.g., 'OptedOut')
		const indepentSelectOptions = this.field().config().options.filter(opt => opt.indepentSelect);

		// Check if the current value being changed is an "independent select" option
		const indepentSelect = this.field().config().options.find(opt => opt.value == value)?.indepentSelect;

		// Get the current selected values (pending or actual)
		const values = this.field().pendingValue() ?? this.field().actualValue();

		// Remove any values that are no longer valid options
		const filteredModel = values.filter(data => this.field().config().options.map(opt => opt.value).includes(data));

		let model: T[] = [];

		// If checking an "independent select" option, only select that option and deselect all others
		if (checked && indepentSelect) {
			model = [value];
		}
		// If checking a regular option, remove any "independent select" options from the selection
		else if (checked && !indepentSelect) {
			model = [...filteredModel.filter(m => !indepentSelectOptions.map(opt => opt.value).includes(m)), value];
		}
		// If unchecking any option, simply remove it from the selection
		else {
			model = filteredModel.filter(data => data !== value);
		}
		
		this.processChange(model);

	}

	public async onBlur() {
		await this.processBlur();
	}

	protected renderValue(value: T) {
		const values = this.field().pendingValue() ?? this.field().actualValue();

		return values.includes(value);
	}


	protected validate(values: T[]): string {

		const config = this.field().config();
		const labels = this.labels();

		if (!values.length && config.isRequired) return labels.missingRequired();
		if (values.length && values.find(v => !config.options.map(opt => opt.value).includes(v))) return labels.invalidSelection();

		return '';
	}


	public setFocus() {
		console.error('setFocus() not implemented');
	}


	protected override valuesAreSame(value1: T[], value2: T[]): boolean {
		return this.util.values.areSame(value1 || [], value2 || []);
	}
}